import { useAuthStore } from "@lib/auth/authStore";
import { useUserQuery, useUserStore } from "@lib/stores/user.store";
import { useEffect } from "react";

export const useCurrentUser = () => {
  const authUserId = useAuthStore((state) => state.userId);
  const setUserInStore = useUserStore((state) => state.setUser);
  const clearUserInStore = useUserStore((state) => state.clearUser);

  const userQuery = useUserQuery({
    userId: authUserId,
    enabled: !!authUserId,
    onSuccess: (data) => {
      setUserInStore(data);
    },
  });

  useEffect(() => {
    if (!authUserId) {
      clearUserInStore();
    }
  }, [authUserId, clearUserInStore]);

  return {
    user: userQuery.data,
    isLoading: userQuery.isLoading,
    isError: userQuery.isError,
    error: userQuery.error,
    isFetching: userQuery.isFetching,
    isSuccess: userQuery.isSuccess,
    refetch: userQuery.refetch,
  };
};
